import React from 'react';
import styled from 'styled-components';
import capitalize from 'lodash/capitalize';

import { getTranslatedString } from 'helpers/i18n';
import { toFriendlyDateString } from 'helpers/Formatter';

const StyledContainer = styled.div`
  margin-top: 20px;
`;

const StyledText = styled.p`
  font-size: 1rem;
  margin: 0px;
`;

const StyledTitle = styled.p`
  font-size: 1.1rem;
  font-weight: 600px;
  margin: 0px;
`;

const LeaseReview = ({ lease_review }) => {
  if (lease_review.status === 'pending') return null;

  return (
    <StyledContainer>
      <StyledTitle>
        {getTranslatedString('landlordPortal.leaseCreatorV2.leasePreviewPage.status')}:{' '}
        {capitalize(lease_review.status)}
      </StyledTitle>
      <StyledText>
        {getTranslatedString('landlordPortal.leaseCreatorV2.leasePreviewPage.note')}:{' '}
        {lease_review.notes}
      </StyledText>
      <StyledText>
        {getTranslatedString('landlordPortal.leaseCreatorV2.leaseReview.reviewedByOn', {
          name: lease_review.reviewer_name,
          date: toFriendlyDateString(lease_review.created_at),
        })}
      </StyledText>
    </StyledContainer>
  );
};

export default LeaseReview;
